import { render, staticRenderFns } from "./editCode.vue?vue&type=template&id=53ce5569&scoped=true&"
import script from "./editCode.vue?vue&type=script&lang=js&"
export * from "./editCode.vue?vue&type=script&lang=js&"
import style0 from "./editCode.vue?vue&type=style&index=0&id=53ce5569&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ce5569",
  null
  
)

export default component.exports